import React, { useState } from 'react';
import Quemsomos from '../../ingles/Who'
import { Container, Row, Col, Carousel, Card, Nav } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importando o Bootstrap
import { Link } from 'react-router-dom';
import Contact from '../../ingles/Contact';
import um from '../../img/Manutencao/1.jpg';
import dois from '../../img/Manutencao/2.png';
import tres from '../../img/Manutencao/3.jpg';
import quatro from '../../img/Manutencao/4.jpg';
import cinco from '../../img/Manutencao/5.jpg';
import seis from '../../img/Manutencao/6.png';
import sete from '../../img/Manutencao/7.jpg';
import oito from '../../img/Manutencao/8.jpg'
import consultoria from '../../img/consultoria.png'
import predial from '../../img/predial.png'
import ti from '../../img/ti.png'
import './ingles.css'
import { Helmet } from 'react-helmet';

import Clients from '../Clientes';
import QuoteButton from '../QuoteButton';

const Ingles = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // Aqui você pode adicionar a lógica para enviar os dados, por exemplo, via API
    setIsSubmitted(true);
    // Limpar o formulário após envio
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };
  
  return (
    <div>
<Helmet>
  <html lang="en" />
  <title>Home | Building Maintenance & information technology Solutions</title>
  <meta name="description" content="We offer expert solutions in building maintenance, information technology infrastructure, and business consulting. Personalized support for your company." />
  <meta name="keywords" content="building maintenance, information technology services, consulting, technical support, business solutions" />
  <meta property="og:title" content="Home | Building Maintenance & information technology Solutions" />
  <meta property="og:description" content="Comprehensive services in maintenance and technology for businesses. Discover how we can help you." />
  <meta property="og:image" content="https://seudominio.com/img/destaque.jpg" />
  <meta property="og:url" content="https://seudominio.com/en" />
  <meta name="robots" content="index, follow" />
</Helmet>
<div style={{ fontFamily: 'Montserrat, sans-serif', }}>

<section className="section2" style={{ marginTop: "100px", marginBottom: "120px" }}>
<Carousel className="carousel12">
<Carousel.Item className="carouseli1" style={{ height: 'calc(85vh - 2.25rem)' }} />
<Carousel.Item className="carouselli2" style={{ height: 'calc(85vh - 2.25rem)' }} />
<Carousel.Item className="carouselli3" style={{ height: 'calc(85vh - 2.25rem)' }} />
</Carousel>

<div style={{ height: "6.25rem", backgroundColor: "#ff5722", position: "relative" }}>
{/* White square inside the div */}
<div style={{
width: "16.25rem", // Width of the square
height: "6.25rem", // Height of the square
backgroundColor: "white", // Color of the square
position: "absolute", // To keep the square inside the parent div
}}></div>
</div>

<div id="quem-somos"></div>
</section>;
<QuoteButton/>
{/* Quem Somos e Referências */}
<Quemsomos/>
{/* Servicos */}
<section style={{ marginBottom: '190px' }}>
  <Container>
    <h2 className="text-center" style={{ position: 'relative', fontSize: '46px', display: 'inline-block' }}>
      <b>Services</b>
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: '0',
        width: '50%', // Ajuste a largura do sublinhado para cobrir a parte desejada
        height: '2px',
        backgroundColor: '#ff5722' // Cor do sublinhado
      }}>

      </div>
    </h2>
    <Row className="d-flex justify-content-between">
<Col
md={3}
className="d-flex justify-content-end"
style={{
backgroundColor: '#ffe7e0',
minHeight: '400px',
paddingRight: '10px',
padding: '20px',
display: 'flex',
flexDirection: 'column',
transition: 'transform 0.3s ease-in-out', // Animação suave
}}
onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'} // Aumenta o tamanho ao passar o mouse
onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'} // Retorna ao tamanho normal
>
<div className="text-left" style={{ flexGrow: 1 }}>
<div className="text-center">
  <img
    src={predial}
    alt="Imagem 3"
    className="img-fluid"
    style={{ height: '100px', marginBottom: '15px' }}
  />
  <h5 style={{ color: '#ff5722', fontSize: '18px' }}>Building Maintenance</h5>
</div>
<p>We offer specialized building maintenance services, ensuring the preservation and proper functioning of all systems and structures of your property.</p>
</div>
<Link to="/Building">
<Button style={{ backgroundColor: '#FF5722', borderColor: '#FF5722', width: '115px', padding: '10px' }}>
  Learn more
</Button>
</Link>
</Col>

<Col
md={3}
className="d-flex justify-content-center"
style={{
backgroundColor: '#ffe7e0',
minHeight: '400px',
padding: '20px',
display: 'flex',
flexDirection: 'column',
transition: 'transform 0.3s ease-in-out',
}}
onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
>
<div className="text-left" style={{ flexGrow: 1 }}>
<div className="text-center">
  <img
    src={ti}
    alt="Imagem 2"
    className="img-fluid"
    style={{ height: '100px', marginBottom: '15px', padding: '20px' }}
  />
</div>
<h5 style={{ color: '#ff5722', fontSize: '18px' }}>Information Technology</h5>
<p>We offer optimization of your company's digital infrastructure, improving
   connectivity and the security of your systems. We operate in various areas such 
   as network implementation and maintenance,
   technical support, ensuring the best performance and protection of your data. </p>
</div>
<Link to="/InformationTechnology">
<Button style={{ backgroundColor: '#FF5722', borderColor: '#FF5722', width: '115px', padding: '10px' }}>
  Learn more
</Button>
</Link>
</Col>

<Col
md={3}
className="d-flex justify-content-end"
style={{
backgroundColor: '#ffe7e0',
minHeight: '400px',
paddingRight: '10px',
padding: '20px',
display: 'flex',
flexDirection: 'column',
transition: 'transform 0.3s ease-in-out',
}}
onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
>
<div className="text-center" style={{ flexGrow: 1 }}>
<img
  src={consultoria}
  alt="Imagem 3"
  className="img-fluid"
  style={{ height: '100px', marginBottom: '15px' }}
/>
<h5 style={{ color: '#ff5722', fontSize: '18px' }}>Consultancy</h5>
<p> We offer customized solutions for the effective management of building maintenance and 
  information technology. We help your company identify specific needs, implement improvements,
   and optimize processes with a focus on efficiency, security, and reducing operational costs.</p>
</div>
<Link to="">
<Button style={{ backgroundColor: '#FF5722', borderColor: '#FF5722', width: '115px', padding: '10px' }}>
  Learn more
</Button>
</Link>
</Col>
</Row>


  </Container>
  <div id='projectos'></div></section>
{/* Projectos */}
<section style={{ marginBottom: '190px' }}>
  <Container>
    <h2 className="text-center" style={{ position: 'relative', fontSize: '46px', display: 'inline-block' }}>
      <b>Projects</b>
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: '0',
        width: '50%', // Ajuste a largura do sublinhado para cobrir a parte desejada
        height: '2px',
        backgroundColor: '#ff5722' // Cor do sublinhado
      }}>

      </div>
    </h2>
    <Carousel interval={null}  > {/* Desabilitando transição automática e indicadores de navegação */}
     
     <Carousel.Item style={{height:'40vh'}}>
       <div className="d-flex justify-content-between" >
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={um}
             alt="Primeira imagem"
             style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px', }}
           />
         </div>
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={dois}
             alt="Segunda imagem"
             style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px', }}
           />

         </div>
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={oito}
             alt="Terceira imagem"
             style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px', }}
           />
         </div>
       </div>
     </Carousel.Item>
     <Carousel.Item style={{height:'40vh'}}>
       <div className="d-flex justify-content-between" >
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={quatro}
             alt="Primeira imagem"
             style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px', }}
           />
         </div>
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={cinco}
             alt="Segunda imagem"
             style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px', }}
           />

         </div>
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={seis}
             alt="Terceira imagem"
             style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px',}}
           />
         </div>
       </div>
     </Carousel.Item>
     <Carousel.Item style={{height:'40vh'}}>
       <div className="d-flex justify-content-between" >
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={sete}
             alt="Primeira imagem"
             style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px', }}
           />
         </div>
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={oito}
             alt="Segunda imagem"
             style={{ objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px', }}
           />

         </div>
         <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
           <img
             className="card-img-top"
             src={um}
             alt="Terceira imagem"
             style={{objectFit: 'cover',height: '190px',width: '80%',borderRadius: '8px',}}
           />
         </div>
       </div>
     </Carousel.Item>

   </Carousel>
    <div className="text-center" style={{ fontSize: '30px' }}>We combine expertise in: <span style={{ color: '#ff5722' }}>Building Maintenance</span> and <span style={{ color: '#ff5722' }}>Information Technology</span></div>

  </Container>

</section>
{/* Clientes */}
      <Clients/>
{/* Contacto */}
<Contact />

</div>

    </div>
   
  );
};

export default Ingles;